import { Component, forwardRef, Input, OnInit } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'brn-chips-input',
  templateUrl: './chips-input.component.html',
  styleUrls: ['./chips-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ChipsInputComponent),
      multi: true,
    },
  ],
})
export class ChipsInputComponent implements ControlValueAccessor {
  $value!: string[];
  newChipValue!: string;

  @Input()
  set value(val) {
    this.$value = val;
    this.onChange(this.$value);
  }
  get value(): any {
    return this.$value;
  }

  @Input()
  placeholder = 'Type values...';

  constructor() {}

  removeChip(index: number): void {
    this.value.splice(index, 1);
  }

  addChip(): void {
    const chip = this.newChipValue.trim();
    if (chip) {
      this.value.push(chip);
      this.newChipValue = '';
    } else {
      return;
    }
  }

  get chips(): string[] {
    return this.value;
  }

  // -------- Value Accessor requirement --------

  onChange(_: any): any {}

  writeValue(value: any): void {
    this.value = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {}
}
